<template>
  <div>
    <hr style="margin-top:50px;opacity:0.15" />
    <el-row>
      <div class="maincon">
        <div class="coman">
          <!-- <div class="div-img">
            <p class="con-p">敢于追求极致，持续创造惊喜</p>
            <div class="img-con">
              <img src="../../assets/img/bg/QRcode.png" />
              <div id="saoyisao">扫一扫了解更多详情</div>
            </div>
          </div> -->
<!-- 
          <div class="main-contwo">
            <div class="two">
              <p style="font-size:20px;margin-bottom: 30px;">联系方式</p>
              <p style="font-size:20px;margin-bottom: 30px;">0755-66681553</p>
              <p style="font-size:20px;margin-bottom: 30px;">recruit@gdbbk.com</p>
              <p style="font-size:16px;margin-bottom: 28px;">深圳市南山区卓越前海壹号T3栋29楼</p>
            </div>
          </div> -->
        </div>
      </div>
    </el-row>
    <div>
      
      <p style="font-size: 80%;text-align: center;margin-bottom:10px">
        
        <span>{{phone}}</span><span> | 联系地址：</span><span> {{address}} </span>
      </p>
      <p style="font-size: 80%;text-align: center;margin-bottom:10px">
        <!-- {{CopyrightTxt}} -->
        
        <span>
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#2c3e50">{{ICPTxt}}</a>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data () {
      return {
          CopyrightTxt:'',
          ICPTxt:'',
          phone:'',
          address:'',
           websiteType:0, 
          //  1  ilegong  2 wl 3 daozheng  0 ts
      }
  },
  created(){
      console.log(window.location.href);
      if(window.location.href.indexOf('ilegong.cn')>=0){
        this.websiteType =1;
      }else if(window.location.href.indexOf('hnwltech.com')>=0){
        this.websiteType =2;
      }else if(window.location.href.indexOf('hndaozheng.com')>=0){
        this.websiteType =3;
      }else{
        this.websiteType =0;
      }
   
      if(this.websiteType ==1){
          this.CopyrightTxt = 'Copyright 2018-2020 重庆乐工网络科技有限公司版权所有 |';
          this.ICPTxt ='渝ICP备2022008421号-1';
          this.phone ='0746-3251798';
          this.address ='湖南省永州祁阳市金盆西路152号';

      }else if(this.websiteType ==2){
          this.CopyrightTxt = 'Copyright 2018-2020 湖南浯浪科技有限公司版权所有 |';
          this.ICPTxt ='湘ICP备2022012834号-1';
          this.phone ='0746-3251798';
          this.address ='湖南省永州祁阳市金盆西路152号';
        
      }else if(this.websiteType ==3){
          this.CopyrightTxt = 'Copyright 2018-2020 湖南道政科技有限公司版权所有 |';
          this.ICPTxt ='湘ICP备2022012864号-1';
          this.phone ='17722593562';
          this.address ='深圳南山区深湾汇h栋1915';
        
      }else if(this.websiteType ==0){
          this.CopyrightTxt = 'Copyright 2018-2020 腾盛软件科技有限公司版权所有 |';
          this.ICPTxt ='粤ICP备20042810号';
          this.phone ='0755-66681553';
          this.address ='深圳市南山区卓越前海壹号T3栋29楼';
        
      }


  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.main-con {
  width: 30%;
  /* display: flex; */
  position: relative;
  padding-left: 8%;
  padding-right: 10%;
}
.contwo {
  text-align: center;
  width: 300px;
  /* margin: 0 auto; */
}
.contwo p {
  text-align: left;
  /* margin-left: -97px; */
  width: 155px;
  margin-top: 0;
  padding-left: 10px;
}
.con-p {
  font-size: 20px;
  /* font-weight: bold; */
  margin-bottom: 10px;
  width: 100%;
}

.coman {
  width: 80%;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}

.div-img {
  flex: 1;
  text-align: left;
}

.maincon {
  display: flex;
}

.main-contwo {
  width: 50%;
  flex: 1;
}

.div-img img {
  width: 140px;
}

.img-con {
  padding-left: 3%;
}

#saoyisao {
  width: 140px;
  text-align: center;
  margin-top: -6px;
}

.two {
  padding-right: 10px;
}

.two p {
  text-align: right;
  /* margin-bottom: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue